import API from "../../../../../global/api";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { getHybridAndCompleteData } from "../InventoryLedger/InventoryLedger.action";
import jsPDF from "jspdf";
import moment from "moment";
// import _ from "lodash";


export const requestAddPurchase = () => {
  return {
    type: "REQUEST_ADD_PURCHASE",
  };
};
export const successAddPurchase = (data) => {
  return {
    type: "SUCCESS_ADD_PURCHASE",
    payload: data,
  };
};
export const errorAddPurchase = () => {
  return {
    type: "ERROR_ADD_PURCHASE",
  };
};
export const addPurchaseApi = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestAddPurchase());
    API.post(`/purchase/`, data).then((res) => {
      // dispatch(getPurchaseApi());
      dispatch(successAddPurchase(data));
      dispatch(getHybridAndCompleteData())
      handleVisible(res.data.message);
    }).catch((error) => {
      dispatch(errorAddPurchase());
      handleDangerVisible(error.response.data.message);
    });
  };
};


export const requestGetPurchase = () => {
  return {
    type: "REQUEST_GET_PURCHASE",
  };
};
export const successGetPurchase = (data) => {
  return {
    type: "SUCCESS_GET_PURCHASE",
    payload: data,
  };
};
export const errorGetPurchase = () => {
  return {
    type: "ERROR_GET_PURCHASE",
  };
};
export const getPurchaseApi = () => {
  return (dispatch) => {
    dispatch(requestGetPurchase());
    API.get(`/purchase/`).then((res) => {
      let getData = res.data;
      dispatch(successGetPurchase(getData));
    }).catch((error) => {
      dispatch(errorGetPurchase());
    });
  };
};


export const DeleteRequestPurchase = () => {
  return {
    type: "DELETE_REQUEST_PURCHASE",
  };
};
export const DeleteSuccessPurchase = (id) => {
  return {
    type: "DELETE_SUCCESS_PURCHASE",
    _id: id,
  };
};
export const DeleteErrorPurchase = () => {
  return {
    type: "DELETE_ERROR_PURCHASE",
  };
};
export const deletePurchaseApi = (id) => {
  return dispatch => {
    dispatch(DeleteRequestPurchase());
    API.delete(`/purchase/${id}`).then(res => {
      dispatch(getPurchaseApi());
      dispatch(DeleteSuccessPurchase(id))
    }).catch((error) => {
      dispatch(DeleteErrorPurchase())
    });
  }
};


export const UpdateRequestPurchase = () => {
  return {
    type: "UPDATE_REQUEST_PURCHASE",
  };
};
export const UpdateSuccessPurchase = (data) => {
  return {
    type: "UPDATE_SUCCESS_PURCHASE",
    payload: data,
  };
};
export const UpdateErrorPurchase = () => {
  return {
    type: "UPDATE_ERROR_PURCHASE",
  };
};
export const updatePurchaseApi = (data, oldData) => {
  return dispatch => {
    dispatch(UpdateRequestPurchase());
    API.put(`/purchase/${oldData._id}`, {
      manualPurchaseNumber: data.manualPurchaseNumber,
      purchaseDate: data.purchaseDate,
      purchaserName: data.purchaserName,
      suplierName: data.suplierName,
      description: data.desc,
    }, {
    }).then(res => {
      dispatch(getPurchaseApi());
      dispatch(UpdateSuccessPurchase([data]))
    }).catch((error) =>
      dispatch(UpdateErrorPurchase()));
  }
};


export const requestGetPurchaseWithId = () => {
  return {
    type: "REQUEST_GET_PURCHASE_WITH_ID",
  };
};
export const successGetPurchaseWithId = (data) => {
  return {
    type: "SUCCESS_GET_PURCHASE_WITH_ID",
    payload: data,
  };
};
export const errorGetPurchaseWithId = () => {
  return {
    type: "ERROR_GET_PURCHASE_WITH_ID",
  };
};
export const getPurchaseWithIdApi = (id) => {
  return (dispatch) => {
    dispatch(requestGetPurchaseWithId());
    API.get(`/purchase/${id}`).then((res) => {
      let getData = res.data;
      dispatch(successGetPurchaseWithId(getData));
    }).catch((error) => {
      dispatch(errorGetPurchaseWithId());
    });
  };
};


export const requestUpdatePurchaseStatus = () => {
  return {
    type: "REQUEST_UPDATE_PURCHASE_STATUS",
  };
};
export const successUpdatePurchaseStatus = (purchaseId) => {
  return {
    type: "SUCCESS_UPDATE_PURCHASE_STATUS",
    payload: purchaseId,
  };
};
export const errorUpdatePurchaseStatus = () => {
  return {
    type: "ERROR_UPDATE_PURCHASE_STATUS",
  };
};
export const updatePurchaseStatusApi = (purchaseId) => {
  return (dispatch) => {
    dispatch(requestUpdatePurchaseStatus());
    API.post(`/purchase/update_purchase_status/${purchaseId}`).then((res) => {
      dispatch(getPurchaseApi());
      dispatch(successUpdatePurchaseStatus(purchaseId));
    }).catch((error) => {
      dispatch(errorUpdatePurchaseStatus());
    });
  };
};


export const individualPDF = (data) => {
  return (dispatch) => {
    const unit = "pt";
    const size = "A4";
    const orientation = "p";
    const doc = new jsPDF(orientation, unit, size);
    PDFHeader(doc, "Purchase Order Details");

    doc.setFont("TimesNewRoman", "Normal");
    doc.setFontSize(11);
    doc.text(`Manual PO Number: ${data.manualPurchaseNumber}`, 25, 125, 0, 20);
    doc.text(`Purchase Order Date: ${data.purchaseDate}`, 25, 140, 0, 20);
    doc.text(`Purchaser Name: ${data.purchaserName}`, 25, 155, 0, 20);
    doc.text(`Suplier Name: ${data.suplierName}`, 25, 170, 0, 20);
    doc.text(`Purchase Order Status: ${data.status}`, 25, 185, 0, 20);

    const headers = [[
      "S.No",
      "Product Name",
      "Quantity",
    ]];
    const productArray = data?.data.map((x, i) => [
      i + 1,
      x.inventoryLabel,
      x.demandedQty,
    ]);
    let content = {
      margin: {
        left: 25,
        right: 25,
      },
      // startX: 25,
      startY: 200,
      styles: {
        fontSize: 9,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      head: headers,
      body: productArray,
      theme: 'grid',
    };
    doc.autoTable(content);


    doc.setProperties(`Order Print ${moment().format("YYYY-MM-DD")}`);
    var blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
  };
};